import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalizationService } from '../../services/localization.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SubheaderService } from 'src/app/core/_base/layout';

@Component({
  selector: 'kt-contact-setting',
  templateUrl: './contact-setting.component.html',
  styleUrls: ['./contact-setting.component.scss']
})
export class ContactSettingComponent implements OnInit {

  selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
  contactSettingsForm:FormGroup;
  resultSet:any;
  disabled:boolean;
  singularName: string;
  pruralName:string;
  chooseContactOwnerFlag;
  serialKeyUpdated: boolean;
  id:number;
  errorMes:string="";
  currentRouteUrl: string;
  prevsingularName: string;
  prevpruralName: string;
  @Output() updateContactTabLabel = new EventEmitter<string>();
  @Output() saveAndExit = new EventEmitter<boolean>();
  unsavedChanges = false;

  constructor(private fb: FormBuilder,
     private contactService: LocalizationService,
     private SpinnerService: NgxSpinnerService,
     private router: Router,
    private subheaderService: SubheaderService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.currentRouteUrl = this.router.url;
    if(this.currentRouteUrl.search('set-assist') > 0){
      this.subheaderService.setTitle('Contact');
    }
    this.contactSettingsForm = this.fb.group({
      singularName: ['', Validators.compose([ Validators.required])],
      pruralName:['', Validators.compose([ Validators.required])],
      serialKey: ['', Validators.compose([ Validators.required])],
      chooseContactOwnerFlag:['', Validators.compose([ Validators.required])]     
     });
     this.getSettingsValues();
     this.disabled=false;
  }

  getSettingsValues(){
    this.SpinnerService.show();
    this.contactService.getContactSettings(this.selectedProject).subscribe(
      res=>{
        console.log(res['responseData']);
        this.resultSet=res['responseData'];
        this.singularName=this.resultSet.singularName;
        this.updateContactTabLabel.emit(this.resultSet.singularName);
        this.pruralName=this.resultSet.pruralName;
        this.chooseContactOwnerFlag=this.resultSet.ownershipFlag.toString();
        this.id=this.resultSet.id;
        this.prevsingularName=this.resultSet.singularName;
        this.contactSettingsForm.controls.serialKey.setValue(this.resultSet.serialKey);
        this.serialKeyUpdated=this.resultSet.serialKeyUpdatedFlag  == 0 ? false : true;
        if(this.serialKeyUpdated){
          this.contactSettingsForm.controls.serialKey.disable();
        }
        this.prevpruralName=this.resultSet.pruralName;
        this.SpinnerService.hide();
        this.setupFormValueChanges();
      },
      err=>{
        console.log(err);
      }
    )
  }
  setupFormValueChanges(): void {
    this.contactSettingsForm.valueChanges.subscribe(() => {
      if (this.contactSettingsForm.dirty) {
        this.unsavedChanges=true;
      }
    });
  }


  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.contactSettingsForm.controls[controlName];
    if (!control) {
      return false;
    }
  
    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }


  Save(calledFromParent:boolean=false){
    this.disabled=true;
    const controls = this.contactSettingsForm.controls;
    if (this.contactSettingsForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      this.disabled=false;
      return;
    }
       
    const addSettingsData = {
        "projectId": this.selectedProject,  
        "singularName":controls.singularName.value.trim(),
        "pruralName":controls.pruralName.value.trim(),
        "id": this.id,
        "ownershipFlag":controls.chooseContactOwnerFlag.value,
        "serialKey":controls.serialKey.value.trim()
    };
    this.disabled=false;
   // console.log(addSettingsData);
    
    this.contactService.saveContactSettings(addSettingsData).subscribe(
      data => {
        if(data['statusCode']>=400){
          this.handleErrorForEditActivity(data['statusCode']);
          return;
         } 
        if(!(this.prevsingularName == this.contactSettingsForm.controls.singularName.value) ||
          !(this.prevpruralName == this.contactSettingsForm.controls.pruralName.value)){
            this.snackBar.open('Renamed value will appear on your next login', '', {
              duration: 2000,
            });
          }else{
            this.snackBar.open('Settings updated.', '', {
              duration: 3000,
              panelClass: ['green-snackbar']
            });
          }
          this.disabled=false;
        this.getSettingsValues();

        if(calledFromParent){
          this.saveAndExit.emit(true);
        }
        this.contactSettingsForm.markAsPristine();
      },
      error =>{
        this.errorMes=error.error.responseData;
        this.snackBar.open(this.errorMes, '', {
          duration: 3000,
          panelClass: ['red-snackbar']
        });
      }
      
    );
    this.unsavedChanges =false;
  }

  Cancel(){
    this.disabled=true;
    this.getSettingsValues();
    this.contactSettingsForm.markAsPristine();
    this.unsavedChanges =false;
    this.disabled=false;
  }
  
  isDisabled() : boolean {
    return this.disabled;
   }

   handleErrorForEditActivity(statusCode: number) {
    let message: string = "";
    if(statusCode == 409){
      message = 'Serial No. Key already exist.';
    }
    else {
      message = 'Unable to save, please try again.';
    }
    this.snackBar.open(message, '', {
      duration: 3000,
      panelClass: ['red-snackbar']
    });
  }

}
